import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Card } from '@ouropix/ui';
import { CardHeader } from '@ouropix/ui';
import { Shield } from 'lucide-react';
import { useAdminGeolocation } from '@/hooks/useAdminGeolocation';
import { useAdminForgotPassword } from '@/hooks/useAdminForgotPassword';
import { ForgotPasswordFlow } from '@/components/auth/ForgotPasswordFlow';
import { GPSBadge } from '@/components/auth/GPSBadge';
import type { ForgotPasswordGps } from '@/lib/auth';

export const Route = createFileRoute('/forgot-password')({
  component: ForgotPasswordPage,
});

function ForgotPasswordPage() {
  const navigate = useNavigate();
  const geo = useAdminGeolocation();
  const gpsAvailable = !geo.denied && !geo.loading && geo.lat !== null;
  const canSubmit = gpsAvailable;

  const snapshotGps = (): ForgotPasswordGps => ({
    lat: Number(geo.lat ?? 0),
    lon: Number(geo.lon ?? 0),
    accuracy: geo.accuracy ?? null,
  });

  const forgotFlow = useAdminForgotPassword({
    gps: snapshotGps,
    canSubmit,
    onSuccess: () => navigate({ to: '/login' }),
  });

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-muted p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1 text-center">
          <div className="mb-4 flex justify-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
              <Shield className="h-8 w-8 text-primary" />
            </div>
          </div>
        </CardHeader>
        <ForgotPasswordFlow
          flow={forgotFlow}
          canSubmit={canSubmit}
          gpsBadge={<GPSBadge geo={geo} gpsAvailable={gpsAvailable} />}
          onBackToLogin={() => navigate({ to: '/login' })}
        />
      </Card>
    </div>
  );
}
